module.exports = __webpack_public_path__ + "img/splitter-4dir.dc394ecd.png";